module.exports = __webpack_public_path__ + "static/sistema_nube-0ae42372a6a8ee0e080002188f15e5ce.png";